import styled from "styled-components";

export const MintModalPhaseThree = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  flex-direction: column;
  align-items: center;
`

export const Figures = styled.img`
  height: 10vh;
`

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 0.5rem;
  background: rgba(11, 19, 103, 1);
  border: solid ${({ theme }) => theme.frameWidth} rgba(11, 19, 103, 1);
  gap: 1rem;
`
